export default __webpack_public_path__ + "static/urzadpom-cea303ef0f19507c9eaa68f68b022bc3.png";